module.exports = __webpack_public_path__ + "static/media/completedApplication.6b9b28fa.svg";